import type { NoteFigure } from '../types';
import type { RhythmFigureId } from '../../lib/rhythm/rhythmTokens';
import { rhythmFigureSprite } from '../../lib/rhythm/rhythmFigureSprites';

/** Duración VexFlow para cada figura de Boom Patrones. */
export const BOOM_FIGURE_VEX_DURATION: Record<NoteFigure, string> = {
  redonda: 'w',
  blanca: 'h',
  negra: 'q',
  corchea: '8',
  semicorchea: '16',
};

/** Figura Eco Rítmico más cercana cuando VexFlow no está disponible. */
export function boomFigureEcoFallback(figure: NoteFigure): RhythmFigureId | null {
  switch (figure) {
    case 'negra':
      return 'negra';
    case 'blanca':
      return 'blanca';
    case 'corchea':
      return 'corchea_doble';
    case 'semicorchea':
      return 'cuartina';
    default:
      return null;
  }
}

export function boomFigureHasEcoSprite(figure: NoteFigure): boolean {
  const ecoId = boomFigureEcoFallback(figure);
  return ecoId != null && rhythmFigureSprite(ecoId) != null;
}
